import { BaseIdRequiredRequest } from "../../../base/request/BaseIdRequiredRequest";
import { TareaEjecucionResponse } from "../response/TareaEjecucionResponse";
import { TareaEjecucionDetalleProductoRequest } from "./TareaEjecucionDetalleProductoRequest";

/** Request de edición de una ejecución de tarea de rastro. Solo edición: `id`
 *  siempre presente (`POST /rastro/tareas-ejecucion/save`, rechaza creación).
 *  Solo permite asignar la tarea y reemplazar el detalle de productos —
 *  geometrías, métricas y fechas no se modifican. */
export type TareaEjecucionRequest = BaseIdRequiredRequest & {
  /** Tarea a asignar a la ejecución (requerido). */
  tareaId: string;
  /** Detalle de productos aplicados. Reemplaza por completo el existente. */
  detalles: TareaEjecucionDetalleProductoRequest[];
};

export const fx_createTareaEjecucionRequest = (
  ejecucion: TareaEjecucionResponse,
): TareaEjecucionRequest => {
  return {
    id: ejecucion.id,
    // "" = sin clasificar todavía (sentinel para el select requerido, igual
    // que el resto de los selects requeridos de la app); la validación del
    // campo bloquea el guardado hasta que se elija una tarea real.
    tareaId: ejecucion.tareaId ?? "",
    detalles: ejecucion.detalles.map((detalle) => ({
      productoId: detalle.productoId,
      dosis: detalle.dosis,
    })),
  };
};
